(function () {
  'use strict';

  angular.module('app').component('productCategoryDetail', productCategoryDetail());

  function productCategoryDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        activeTab: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
        hideTopControls: '<',
      },
      controller: ProductCategoryDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/product-categories/product-category-detail/product-category-detail.component.html',
    };
  }

  ProductCategoryDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'SessionService',
    'AbilityService',
    'MeasurementUnitService',
    'ProductCategoryService',
    'TaxService',

    // Angular downgraded service
    'companyService',
  ];

  function ProductCategoryDetailComponent(
    config,
    UtilService,
    SessionService,
    AbilityService,
    MeasurementUnitService,
    ProductCategoryService,
    TaxService,

    // Angular downgraded service
    companyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canUpdate: AbilityService.can('update_productcategory_accountadmin'),
      canDestroy: AbilityService.can('destroy_productcategory_accountadmin'),
    };

    vm.codingTypes = config.CODING_TYPES;

    // private properties
    // -----------------------
    const fieldsDefinition = [
      'name',
      'description',
      'product_type',
      'coding_type',
      'coding_prefix',
      'coding_length',
      'measurement_unit_id',
    ];

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);

        // getAdditionalLanguages();
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          coding_length: 3,
          company_id: SessionService.getSelectedAccountCompany().id,
        };
      }

      // Initializers
      getCompany();
      getProductTypes();
    };

    // public methods
    // -----------------------
    vm.editProductCategory = function () {
      vm.editMode = true;
      vm.viewMode = false;
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    vm.openTranslations = function () {
      ProductCategoryService.openProductCategoryTranslations(vm.item, vm.additionalLanguages);
    };

    // Create/Update
    vm.saveProductCategory = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      // console.log(vm.item); return;

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        ProductCategoryService.saveProductCategory(vm.item, vm.defaultLanguage).then(function (
          data
        ) {
          let status = data.status;
          let response = data.response;

          if (status) {
            // Success
            vm.measurementUnit = vm.UtilService.findItemInArray(
              vm.measurementUnits,
              'id',
              response.measurement_unit_id
            );

            setItemOptions(response);
            vm.onSavedItem({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      } else {
        vm.cancel();
      }
    };

    vm.cancel = function () {
      /*if (vm.editMode) {
                vm.cancelEdit();
                return;
            }*/

      vm.onCanceledItem(); // { item: vm.item }
    };

    vm.changeProductCategoryStatus = function (productCategory) {
      if (!vm.permissions.canUpdate) return;

      let successCallback = function () {
        vm.onCanceledItem();

        // setItemOptions(vm.item);
        // vm.onSavedItem({ item: 'changed' });
      };

      ProductCategoryService.changeProductCategoryStatus(productCategory, successCallback);
    };

    vm.deleteProductCategory = function (productCategory) {
      if (!vm.permissions.canDestroy) return;

      let successCallback = function () {
        vm.onCanceledItem();

        // setItemOptions(vm.item);
        // vm.onSavedItem({ item: 'changed' });
      };

      ProductCategoryService.deleteProductCategory(productCategory, successCallback);
    };

    vm.selectProductType = function (productType) {
      vm.measurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
        vm.company.measurement_units,
        productType
      );

      if (!vm.createMode) {
        vm.measurementUnit = vm.UtilService.findItemInArray(
          vm.measurementUnits,
          'id',
          vm.item.measurement_unit_id
        );
      }
    };

    // ----- Associate taxes -----
    vm.selectAssociatedTaxes = function () {
      if (vm.taxes) return;

      getTaxes();
    };

    vm.selectAssociatedPrepaymentSettings = function () {
      if (vm.prepaymentSettings) return;

      getPrepaymentSettings();
    };

    vm.selectAccounts = function () {
      if (vm.incomeAccounts) return;

      getIncomeAccounts();
      getExpenseAccounts();
    };

    vm.onAssociatedTaxesSaved = function (productCategory) {
      vm.item = productCategory;
      vm.originalItem = angular.copy(vm.item);

      // vm.taxes         = vm.taxesOriginal;
      // vm.taxesOriginal = angular.copy(vm.taxes);
      // let productCategoryAssociatedTaxes = productCategory.associated_taxes || [];

      setProductCategoryAsociatedTaxes(productCategory.associated_taxes);
    };

    vm.onAssociatedTaxesCanceled = function () {
      vm.productCategoryIsExempt = vm.originalItem.is_exempt;

      vm.taxes = vm.taxesOriginal;
      vm.taxesOriginal = angular.copy(vm.taxes);
    };

    vm.onPrepaymentSettingsSaved = function (productCategory) {
      vm.item = productCategory;
      vm.prepaymentSettings = vm.item.prepayment_settings;
      vm.prepaymentSettingsOriginal = angular.copy(vm.prepaymentSettings);
    };

    vm.onPrepaymentSettingsCanceled = function () {
      vm.prepaymentSettings = vm.prepaymentSettingsOriginal;
      vm.prepaymentSettingsOriginal = angular.copy(vm.prepaymentSettings);
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editProductCategory();
      }

      vm.productCategoryIsExempt = item.is_exempt || false;

      vm.itemName = item.name;

      vm.originalItem = angular.copy(item); // store server data
      vm.prepaymentSettingsOriginal = angular.copy(item.prepayment_settings);
    }

    function getCompany() {
      companyService
        .getCompany(vm.item.company_id, { skip_check_role: true })
        .subscribe((response) => {
          vm.company = response;

          if (vm.company.country.country_setting) {
            vm.taxTypes = vm.company.country.country_setting.tax_types;
            vm.taxRateCodes = vm.company.country.country_setting.tax_rate_codes;
          }

          if (!vm.createMode) {
            vm.selectProductType(vm.item.product_type);

            if (vm.activeTab === 1) {
              // Associated taxes - comming from product
              vm.selectAssociatedTaxes();
            }

            if (vm.activeTab === 2) {
              vm.selectAssociatedPrepaymentSettings();
            }

            if (vm.activeTab === 3) {
              vm.selectAccounts();
            }
          }
        });
    }

    function getProductTypes() {
      vm.productTypes = vm.UtilService.getProductTypes();
    }

    function getTaxes() {
      vm.loadingTaxes = true;
      TaxService.getTaxes({ get: 'sales_and_purchases', skip_check_role: true }).then(function (
        data
      ) {
        // vm.taxes         = TaxService.setAssociatedTaxes(TaxService.items, vm.item.associated_taxes, vm.taxTypes); // , vm.item.exonerations
        // vm.taxesOriginal = angular.copy(vm.taxes);

        vm.defaultTaxes = data.items;

        setProductCategoryAsociatedTaxes(vm.item.associated_taxes);

        vm.loadingTaxes = false;
      });
    }

    function setProductCategoryAsociatedTaxes(associated_taxes) {
      vm.taxes = TaxService.setAssociatedTaxes(vm.defaultTaxes, associated_taxes, vm.taxTypes); // , vm.item.exonerations
      vm.taxesOriginal = angular.copy(vm.taxes);
    }

    function getPrepaymentSettings() {
      vm.prepaymentSettings = vm.item.prepayment_settings || [];
      vm.prepaymentSettingsCopy = angular.copy(vm.prepaymentSettings);
    }

    function getIncomeAccounts() {
      vm.incomeAccount = vm.item.income_account || '';
      vm.incomeAccountCopy = angular.copy(vm.incomeAccount);
    }

    function getExpenseAccounts() {
      vm.expenseAccount = vm.item.expense_account || '';
      vm.expenseAccountCopy = angular.copy(vm.expenseAccount);
    }
  }
})();
